import {PostSurgeryConfirmParams} from 'domain/usecases/private/booking-flow/surgery/post-surgery-confirm';
import {makePostSurgeryConfirm} from 'main/factories/usecases/private/booking-flow/remote-surgery-booking/post-surgery-confirm-factory';

export async function postSurgeryConfirm(params: PostSurgeryConfirmParams) {
	const response = await makePostSurgeryConfirm().post(params);

	return response;
}
